import { render, staticRenderFns } from "./OngoingMovesView.vue?vue&type=template&id=1421eef9"
import script from "./OngoingMovesView.vue?vue&type=script&lang=js"
export * from "./OngoingMovesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports